
  import { defineComponent, isProxy, toRaw, PropType } from "vue";
  import { Folder, FolderUp, Place, Imageset } from "@wwtelescope/engine";
  import { Thumbnail } from "@wwtelescope/engine-types";
  import { WWTAwareComponent } from "@wwtelescope/engine-pinia";
  
  type FlexDirection = "row" | "column";
  
  
  export default defineComponent({
    extends: WWTAwareComponent,
  
    name: 'MyComponent',
      
    props: {
      rootFolder: {
        type: Object as PropType<Folder>,
        required: true
      },
      flexDirection: {
        type: String as PropType<FlexDirection>,
        default: "column"
      },
      expandable: {
        type: Boolean,
        default: false
      },
      sliders: {
        type: Boolean,
        default: false
      },
      startFirstSelected: {
        type: Boolean,
        default: true
      },
      thumbnails: {
        type: Boolean,
        default: true
      },
      open: {
        type: Boolean,
        default: false
      },
      incomingItemSelect: {
        type: Object as PropType<Thumbnail>,
        default: null
      }
      
    },
  
    data() {
      return {
        items: [] as Thumbnail[],
        lastSelectedItem: null as Thumbnail | null,
        opacities: {} as Record<string, number>,
        expanded: this.open,
        lastOpacityChanged: null as Thumbnail | null,
      };
    },
  
    created() {
      this.populate();
    },
  
    methods: {
  
  
      populate(): void {
        for (const c of this.rootFolder.get_children() ?? []) {
          const cr = isProxy(c) ? toRaw(c) : c;
          if (cr instanceof Place) {
            this.items.push(cr);
          }
        }
        if (this.startFirstSelected && this.items?.length > 0) {
          this.selectItem(this.items[0]);
        }
      },
      showSlider(item: Thumbnail | null): boolean {
        return item instanceof Imageset;
      },
      selectItem(item: Thumbnail): void {
        this.lastSelectedItem = item;
        if (item instanceof Folder || item instanceof FolderUp) {
          this.items = item.get_children() ?? [];
        } else {
          this.$emit('select', item);
        }
      },
      onSliderInputChanged(e: Event, item: Thumbnail) {
        let dragging = false;
        if (this.lastOpacityChanged == item) {
          dragging = true;
        } else {
          this.lastOpacityChanged = item;
        }
        this.$emit('opacity', item, (e.target as HTMLInputElement).value, !dragging);
      },
  
      onToggleImage(e: Event, item: Thumbnail) {
        this.$emit('toggle', item, (e.target as HTMLInputElement).checked);
      },
  
      scrollToItem(id: string) {
        const element = document.getElementById(id);
        if (element !== null) {
          const container = document.getElementById("items");
          if (container !== null) {
            console.log(element.clientHeight);
            const y = Math.max(Math.min(element.offsetTop - element.clientHeight * 1.5, container.scrollHeight), 0);
            container.scrollTo(0, y);
          }
        }
      },
    },
  
    computed: {
      cssVars() {
        return {
          "--flex-direction": this.flexDirection
        };
      },
  
      isMobile() {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
      },
    },
  
    watch: {
      incomingItemSelect() {
        if (this.incomingItemSelect != null) {
          this.lastSelectedItem = this.incomingItemSelect;
          this.scrollToItem(`fv-${this.incomingItemSelect.get_name()}`);
        } else {
          this.lastSelectedItem = null;
        }
      }
    }
  });
  